/**
 * App-facing surface: `authApi`, `setAuthApiConfig` (wires `QueryClient` + `setApiConfig`).
 */
import { QueryClient } from '@tanstack/react-query';
import { setApiConfig } from '../api/client';
import { getAuthStore } from './store';
import * as sessionApi from './authSessionApi';
import { isWithinPostLoginGrace } from './session/postLoginSignals';

export { useAuthStore, getAuthStore } from './store';
export type { User, AuthState } from './store';

export const authApi = {
  login: sessionApi.login,
  logout: sessionApi.logout,
  loadStoredUser: sessionApi.loadStoredUser,
  setQueryClient: sessionApi.setQueryClient,
  setLoginJustHappened: sessionApi.setLoginJustHappened,
};

export function setAuthApiConfig(queryClient: QueryClient | null): void {
  sessionApi.setQueryClient(queryClient);
  setApiConfig({
    getToken: () => getAuthStore().user?.session_token ?? null,
    onUnauthorized: () => {
      if (isWithinPostLoginGrace()) {
        return;
      }
      void sessionApi.clearSessionFromStorage();
      queryClient?.clear();
    },
  });
}

